const metadataType = {
    // get metadata
    GET_METADATA: "GET_METADATA",
    GET_METADATA_COMMIT: "GET_METADATA_COMMIT",
    GET_METADATA_ROLLBACK: "GET_METADATA_ROLLBACK",
  };

  
  export default metadataType;